/* eslint-disable indent */
import React from 'react';
import { injectIntl } from 'react-intl';
import { compose } from 'react-apollo';
import { Card, Image, Icon } from 'semantic-ui-react';
import styles from './index.css';
import toHex from 'colornames';
import moment from 'moment';
// eslint-disable-next-line react/prefer-stateless-function
class ShopCard extends React.Component {
  getDiscountPercentage(before, after) {
    return Math.round(((after - before) / after) * 100);
  }
  getColorHexCode = (name) => name.split(/\s|\//).map(toHex).filter(Boolean)[0];
  bySelector = (type) => (s) => s.type === type;
  bySelectorValue = (type, value) => (v) =>
    v &&
    v.selectors &&
    v.selectors.find((s) => this.bySelector(type)(s) && s.value === value);
  uniqWith = (fn, xs) =>
    xs.filter(
      (element, index) => xs.findIndex((step) => fn(element, step)) === index
    );
  sortBy = (key, xs) =>
    // eslint-disable-next-line no-nested-ternary
    xs.sort((a, b) => (a[key] > b[key] ? 1 : b[key] > a[key] ? -1 : 0));
  colorValues =
    !this.props.loading &&
    this.props.sortedSelectors &&
    this.props.sortedSelectors.length &&
    this.props.sortedSelectors.find((s) => s && s.type === 'Color');

  colors =
    this.colorValues && this.colorValues.length
      ? this.colorValues.values.map((v) => ({
          name: v,
          hex: this.getColorHexCode(v),
          varient: this.props.variations.find(this.bySelectorValue('Color', v))
            .id,
          selected:
            v ===
            this.props.defaultVariation.selectors.find(this.bySelector('Color'))
              .value,
        }))
      : [];

  colorsToRender =
    !this.props.loading && this.colors && this.colors.length
      ? this.this
          .sortBy(
            'selected',
            this.uniqWith(
              (x, y) => x.hex === y.hex,
              this.colors.filter((c) => c.hex)
            )
          )
          .reverse()
          .slice(0, 6)
      : [];

  product({ slug, variationId = null }) {
    return `https://shop.lynks.com/products/${slug}${
      variationId ? `/${variationId}` : ''
    }`;
  }

  render() {
    return (
      <Card style={{ width: '250px', height: '100%', margin: '0 auto' }}>
        <div
          style={{
            color: '#fff',
            backgroundColor: '#4F46E5',
            width: 'fit-content',
            padding: '0.25rem 0.5rem',
            fontStyle: 'italic',
            border: '0 solid #e5e7eb',
            margin: '0.5rem 1rem',
            position: 'absolute',
            zIndex: 1,
            direction: 'ltr',
            gap: '0.4rem',
          }}
          id={styles.express}
        >
          Express
          <Icon name="check circle outline" />
        </div>
        {this.props.loading ? (
          <div
            style={{ backgroundColor: '#eee', height: '250px', width: '250px' }}
          ></div>
        ) : (
          <Image src={this.props.image} wrapped ui={false} />
        )}
        <Card.Content
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            gap: '0.25rem',
          }}
        >
          {this.colorsToRender && this.colorsToRender.length > 1 && (
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0.5rem 0',
              }}
            >
              {this.colorsToRender && this.colorsToRender.length
                ? this.colorsToRender.map((color) => (
                    // eslint-disable-next-line react/jsx-indent
                    <a
                      target="_blank"
                      href={this.product({
                        slug: this.props.slug,
                        variationId: color.varient,
                      })}
                      key={color.name}
                      style={{
                        backgroundColor: color.hex,
                        borderRadius: '50%',
                      }}
                    >
                      <span
                        style={{
                          width: '16px',
                          height: '16px',
                          display: 'block',
                          border: '1px solid white',
                          borderRadius: '50%',
                        }}
                      ></span>
                    </a>
                  ))
                : null}
              {this.colorsToRender.length < this.colors.length ? (
                <span className="text-xs text-indigo-800 hover:underline">
                  <a
                    href={this.product({ slug: this.props.slug })}
                    target="_blank"
                  >
                    +{this.colors.length - this.colorsToRender.length}
                  </a>
                </span>
              ) : null}
            </div>
          )}
          <div style={{ display: 'inline-block' }}>
            <Card.Header
              style={{
                fontSize: '1rem',
                fontWeight: 'normal',
                display: '-webkit-box',
                WebkitLineClamp: 1,
                WebkitBoxOrient: 'vertical',
                overflow: 'hidden',
                direction: 'ltr',
              }}
            >
              <a
                href={`https://shop.lynks.com/products/${this.props.slug}`}
                target="_blank"
              >
                {this.props.title}
              </a>
            </Card.Header>
          </div>
          <Card.Meta
            style={{
              fontSize: '.875rem',
              display: 'flex',
              gap: '0.75rem',
              direction: 'ltr',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <span style={{ textDecoration: 'line-through' }}>
              EGP {this.props.listPriceEgp}
            </span>
            {this.props.priceEgp && this.props.listPriceEgp && (
              <span
                style={{
                  color: '#15803D',
                  backgroundColor: '#DCFCE7',
                  fontWeight: 'bold',
                  borderRadius: '0.5rem',
                  padding: '0.25rem',
                }}
              >
                {this.getDiscountPercentage(
                  this.props.priceEgp,
                  this.props.listPriceEgp
                )}
                % off
              </span>
            )}
          </Card.Meta>
          <Card.Description
            style={{
              color: 'rgb(177, 39, 4)',
              fontWeight: 'bold',
              fontSize: '1.15rem',
            }}
          >
            <span style={{ fontWeight: 'normal' }}>EGP</span>{' '}
            {this.props.priceEgp}
          </Card.Description>
          <div>
            Get it by{' '}
            <span style={{ fontWeight: 'bold' }}>
              {moment()
                .add(this.props.minShippingDays, 'days')
                .format('MMM DD')}
            </span>{' '}
            -{' '}
            <span style={{ fontWeight: 'bold' }}>
              {moment()
                .add(this.props.maxShippingDays, 'days')
                .format('MMM DD')}
            </span>
          </div>
        </Card.Content>
      </Card>
    );
  }
}

export default compose(injectIntl)(ShopCard);



// WEBPACK FOOTER //
// ./app/containers/StaticPage/ComeBack/ShopCard.js